import { StoryblokStory } from 'storyblok-generate-ts';

export function getStoryContent<T extends StoryblokStory<any>>(
	story: T | string | undefined | null,
): T['content'] | undefined {
	if (story == null) return undefined;
	if (typeof story === 'string') return undefined;
	return story.content;
}
